module.exports = __webpack_public_path__ + "img/zombie.6d5b607e.jpg";